import React from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";

export interface ITimeUnitSelectProps {
  timeUnit: "day" | "week" | "month";
  setTimeUnit: (timeUnit: "day" | "week" | "month") => void;
  disabled?: boolean;
}

export const TimeUnitSelect = (props: ITimeUnitSelectProps) => {
  const { timeUnit, setTimeUnit, disabled = false } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`analysisCollectionsPage.collectionChartArea.${key}`);

  return (
    <div className="right-pink-choose">
      <div className="chart-choose-module">
        <button
          disabled={disabled}
          type="button"
          className={`btn items current${timeUnit === "day" ? "current" : ""}`}
          onClick={() => {
            setTimeUnit("day");
          }}
        >
          {t("timeUnitOptions.day")}
        </button>
        <button
          disabled={disabled}
          type="button"
          className={`btn items current${timeUnit === "week" ? "current" : ""}`}
          onClick={() => {
            setTimeUnit("week");
          }}
        >
          {t("timeUnitOptions.week")}
        </button>
        <button
          disabled={disabled}
          type="button"
          className={`btn items current${
            timeUnit === "month" ? "current" : ""
          }`}
          onClick={() => {
            setTimeUnit("month");
          }}
        >
          {t("timeUnitOptions.month")}
        </button>
      </div>
    </div>
  );
};
